import { useIonAlert } from '@ionic/react'

function useDeleteWarning() {
  const [present] = useIonAlert()

  function showDeleteWarning(message: string, handler: () => void) {
    return present({
      header: 'Warning',
      message: `You are about to delete ${message}. This action cannot be undone. Are you sure?`,
      backdropDismiss: false,
      buttons: [
        'Cancel',
        {
          text: 'Delete',
          role: 'destructive',
          handler,
        },
      ],
    })
  }

  return { showDeleteWarning }
}

export { useDeleteWarning }
